import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { formatValueAccordingToRegExp } from '@app/utils/helpers/phoneFormat.helpers';

export function zipPhoneValidator(regular: RegExp | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || regular === null) {
      return null;
    }

    const formattedValue = formatValueAccordingToRegExp(control.value, regular);

    if (!formattedValue) {
      return { regularInvalid: true };
    }

    return regular.test(formattedValue) ? null : { regularInvalid: true };
  };
}

export function cyprusPhoneValidator(phoneReg: RegExp, prefix: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const valueWithoutSpaces = control.value.replace(/\s/g, '');
    const valueWithPrefix = prefix + valueWithoutSpaces;
    const formattedValue = valueWithPrefix.slice(0, 2) + ' ' + valueWithPrefix.slice(2);

    return phoneReg.test(formattedValue) ? null : { regularInvalid: true };
  };
}

export function separatedZipValidator(zipReg: RegExp, prefix: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const valueWithPrefix = prefix + control.value;
    return zipReg.test(valueWithPrefix) ? null : { regularInvalid: true };
  };
}
